/* Enhance the retained Shopify product form; no custom cart transport. */
(() => {
  const init = root => root.querySelectorAll('[data-bj-clothing-product]').forEach(el => {
    if (el.dataset.bjPdpReady) return;
    const select = el.querySelector('[data-bj-variant-select]');
    const form = select?.form;
    const options = el.querySelector('[data-bj-visual-options]');
    if (!select || !form || !options) return;
    const variants = [...select.options].filter(option => option.value);
    const colours = [...el.querySelectorAll('[data-bj-colour-input]')];
    const sizes = [...el.querySelectorAll('[data-bj-size-input]')];
    if (!colours.length || !sizes.length) return;
    el.dataset.bjPdpReady = '1';
    const pricePairs = [...el.querySelectorAll('[data-bj-price] [data-bj-price-pair], [data-bj-sticky-price] [data-bj-price-pair]')];
    const main = el.querySelector('[data-bj-main-add]');
    const sticky = el.querySelector('[data-bj-sticky]');
    const stickyAction = el.querySelector('[data-bj-sticky-action]');
    const sizeFieldset = el.querySelector('[data-bj-size-fieldset]');
    const gallery = el.querySelector('[data-bj-gallery]');
    const photos = [...el.querySelectorAll('[data-bj-gallery-photo]')];
    const modelLinks = [...el.querySelectorAll('[data-bj-model-link]')];
    const thumbHost = el.querySelector('[data-bj-photo-thumbnails]');
    const thumbs = photos.map((photo, index) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'bj-pdp__thumb';
      button.dataset.bjThumb = String(index);
      button.setAttribute('aria-label', photo.querySelector('img')?.alt || `Photo ${index + 1}`);
      button.setAttribute('aria-controls', photo.id);
      const source = photo.querySelector('img');
      if (source) {
        const image = document.createElement('img');
        const url = new URL(source.src, location.href);
        url.searchParams.set('width', '160');
        image.src = url.href;
        image.alt = '';
        image.width = 64;
        image.height = 80;
        image.loading = 'lazy';
        button.append(image);
      }
      thumbHost?.append(button);
      return button;
    });
    const eligible = variant => variant?.dataset.bjAvailable === 'true';
    const find = (colour, size) => variants.find(v => v.dataset.bjColour === colour && v.dataset.bjSize === size);
    const explicit = select.dataset.bjExplicitVariant === 'true';
    const initial = select.selectedOptions[0];
    let colour = initial?.dataset.bjColour || colours.find(input => input.checked)?.value || colours[0].value;
    let size = explicit ? initial?.dataset.bjSize || null : null;
    let selected = null;
    let previousColour;
    const visiblePhotos = () => photos.filter(photo => !photo.hidden);
    const scrollToPhoto = photo => {
      if (!photo || photo.hidden || !gallery) return;
      gallery.scrollTo({left: photo.offsetLeft - visiblePhotos()[0].offsetLeft, behavior: 'instant'});
      photo.focus({preventScroll: true});
    };
    const updateThumbs = () => {
      const visible = visiblePhotos();
      if (!gallery || !visible.length) return;
      let active = visible[0];
      let distance = Infinity;
      visible.forEach(photo => {
        const delta = Math.abs(photo.offsetLeft - visible[0].offsetLeft - gallery.scrollLeft);
        if (delta < distance) { distance = delta; active = photo; }
      });
      const counter = el.querySelector('[data-bj-gallery-count]');
      if (counter) counter.textContent = `${visible.indexOf(active) + 1} / ${visible.length}`;
      thumbs.forEach((button, index) => {
        const current = photos[index] === active;
        button.classList.toggle('is-active', current);
        button.setAttribute('aria-pressed', String(current));
      });
    };
    thumbs.forEach((button, index) => button.addEventListener('click', () => scrollToPhoto(photos[index])));
    modelLinks.forEach(link => link.addEventListener('click', event => {
      const photo = document.getElementById(link.hash.slice(1));
      if (!photo || photo.hidden) return;
      event.preventDefault();
      scrollToPhoto(photo);
    }));
    gallery?.addEventListener('scroll', updateThumbs, {passive: true});
    const updateSticky = () => {
      if (!sticky || !main) return;
      const rect = main.getBoundingClientRect();
      const galleryCleared = !gallery || gallery.getBoundingClientRect().bottom < innerHeight * 0.8;
      const actionVisible = rect.top < innerHeight - 72 && rect.bottom > 0;
      sticky.hidden = !(innerWidth < 960 && galleryCleared && !actionVisible);
    };
    const sync = () => {
      colours.forEach(input => {
        input.checked = input.value === colour;
        input.disabled = !variants.some(v => v.dataset.bjColour === input.value && eligible(v));
      });
      const colourName = el.querySelector('[data-bj-colour-name]');
      if (colourName) colourName.textContent = colour;
      sizes.forEach(input => {
        input.disabled = !eligible(find(colour, input.value));
        if (input.disabled && size === input.value) size = null;
      });
      sizes.forEach(input => { input.checked = size === input.value; });
      selected = size ? find(colour, size) : null;
      if (!eligible(selected)) selected = null;
      select.value = selected?.value || '';
      const priced = selected || variants.find(v => v.dataset.bjColour === colour && eligible(v));
      if (priced) {
        pricePairs.forEach(pair => {
          const sale = pair.querySelector('[data-bj-sale-money]');
          const compare = pair.querySelector('[data-bj-compare-price]');
          const compareMoney = pair.querySelector('[data-bj-compare-money]');
          const discount = pair.querySelector('[data-bj-discount]');
          const isSale = Boolean(priced.dataset.bjCompare);
          if (sale) sale.textContent = priced.dataset.bjPrice || '';
          if (compare) compare.hidden = !isSale;
          if (compareMoney) compareMoney.textContent = priced.dataset.bjCompare || '';
          if (discount) {
            discount.hidden = !isSale;
            discount.textContent = isSale ? priced.dataset.bjDiscount + '% OFF' : '';
          }
        });
      }
      if (main) { main.disabled = !selected; main.textContent = selected ? 'Add to bag' : 'Choose a size'; }
      const message = el.querySelector('[data-bj-size-help]');
      if (message) message.textContent = selected ? `Selected: ${colour} / ${size}. Ready to add to bag.` : 'Select an available size to continue. Compare with a T-shirt you own.';
       const summary = el.querySelector('[data-bj-sticky-summary]');
       if (summary) summary.textContent = selected ? `${colour} / ${size}` : 'Choose your size';
      if (stickyAction) stickyAction.textContent = selected ? 'Add to bag' : 'Choose size';
      if (colour !== previousColour) {
        const value = colour.toLowerCase();
        photos.forEach((photo, index) => {
          photo.hidden = Boolean(photo.dataset.colour && photo.dataset.colour !== value);
          thumbs[index].hidden = photo.hidden;
        });
        modelLinks.forEach(link => { link.hidden = link.dataset.colour !== value; });
        gallery?.scrollTo({left: 0, behavior: 'instant'});
        previousColour = colour;
      }
      updateThumbs();
      updateSticky();
    };
    colours.forEach(input => input.addEventListener('change', () => { if (input.checked) { colour = input.value; sync(); } }));
    sizes.forEach(input => input.addEventListener('change', () => { if (input.checked) { size = input.value; sync(); } }));
    const chooseSize = () => {
      sizeFieldset?.scrollIntoView({behavior: 'instant', block: 'center'});
      sizes.find(input => !input.disabled)?.focus();
    };
    form.addEventListener('submit', event => { if (!selected) { event.preventDefault(); chooseSize(); } });
    stickyAction?.addEventListener('click', () => { if (selected) form.requestSubmit(main); else chooseSize(); });
    window.addEventListener('scroll', updateSticky, {passive: true});
    window.addEventListener('resize', updateSticky, {passive: true});
    el.classList.add('bj-pdp--enhanced');
    options.hidden = false;
    sync();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), {once: true});
  else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
